import react, {useContext, useEffect, useState} from "react"
import styles from "./CardSlot.module.css"
import encryptJSON from "../../../Utils/encryptJSON";
import {Context} from "../../../../../index";
import ErrorComponent from "../../../../../components/UI/Error/ErrorComponent";
import Spin from "../../../../../components/UI/Spin/Spin"
import SlotsProviders from "../../../Service/SlotsProviders";
import {NAME_SERVER} from "../../../../../Utils/NAME_HOST";
import Img from "../../../../../Utils/ImgLoad/ImgLoad"
import Sound_play from "../../../../../Utils/sound_play";
import { succses_bet } from "../../../../../Utils/sounds";
function CardSlot({img,category_games, setLike_slots,nonLike ,isLike, name, gameCode, vendorCode, provider, RTP, isVpn}) {
    const {store} = useContext(Context)
    const [ImgLoad,setImgLoad] = useState(false);
    const [stateOpen, setStateOpen] = useState(false)
    const [isLikeState, setisLikeState] = useState(isLike)
    const [stateLoad, setStateLoad] = useState(false)
    useEffect(() => {
        const image = new Image();
        image.src = img;
        image.onload = ()=>{
            setStateLoad(true)
        }
    }, []);

    async function response_unlike() {
        try {

            const response = await SlotsProviders.unlike_slot(gameCode,category_games);
            if (response.status === 200) {
                if (response.data.error) {
                    store.add_message(response.data.msg, ErrorComponent)

                }
                if (response.data.status === 1) {
                    Sound_play(succses_bet,store.sound)

                    setisLikeState(false)
                    setLike_slots(response.data.data)


                }
            }
        } catch (e) {
            console.log(e)
            store.add_message("error1", ErrorComponent)

        }
    }

    async function response_like() {
        try {

            const response = await SlotsProviders.like_slot(gameCode,category_games);
            if (response.status === 200) {
                if (response.data.error) {
                    store.add_message(response.data.msg, ErrorComponent)

                }
                if (response.data.status === 1) {
                    Sound_play(succses_bet,store.sound)
                    setisLikeState(true)
                    setLike_slots(response.data.data)

                }
            }
        } catch (e) {
            console.log(e)
            store.add_message("error1", ErrorComponent)

        }
    }

    return (

        <div className={styles.gamecard + " fadeAnimationMain " + (stateLoad ? styles.active_card : styles.loadCard)} onMouseEnter={() => {
            setStateOpen(true)
        }} onMouseLeave={() => {
            setStateOpen(false)
        }}>

            {isLikeState && (<div className={styles.containerLike}>
                <i className="fa-solid fa-heart"></i>
            </div>)}

            <div className={styles.gamecard_window}>
                {!stateLoad?(
                    <div className={styles.skeleton}><img className={styles.preloadimg} src={NAME_SERVER+"/assets/"+"лого.png"} width={16}/></div>
                ):(<img src={img}/>)}
                <div className={styles.gamecard_links} style={{opacity:Number(stateOpen)}}>
                <a href={"/slot_game/" + gameCode+"_"+"real"} onClick={()=>Sound_play(succses_bet,store.sound)} className={`${styles.buttonConnect}`}>{store.dataLang["button_play"]}</a>
                <a href={"/slot_game/" + gameCode+"_"+"demo"} onClick={()=>Sound_play(succses_bet,store.sound)} className={`${styles.buttonConnect} ${styles.demo} ${category_games==="LD"&&(styles.disable_button)}`}>{store.dataLang["demo_name"]}</a>
                {(isLikeState && store.user.id) && (

                    <a className={styles.buttonLike} onClick={async () => {
                        
                        await response_unlike()
                    }}>

                        {store.dataLang["like_state2"]}<i className="fa-solid fa-heart"></i>
                    </a>

                )}
                {(!isLikeState && store.user.id)&&(
                    <a className={styles.buttonLike} onClick={async () => {
                        
                        await response_like()
                    }}>

                        {store.dataLang["like_state1"]}<i className="fa-regular fa-heart"></i>
                    </a>
                )}

            </div>





            </div>
            


            <div className={styles.gamecard_inf}>
                <div className={styles.gamecard_title}>{name}</div>

                <div className={`${styles.footer_card} ${!RTP && styles.footer_card_position_center}`}>
                    {RTP ?(<div className={styles.gamecard_name_provider}>RTP: {RTP}%</div>):(<div className={styles.gamecard_name_provider}><br/></div>)}

                    <div className={styles.gamecard_name_provider}>{provider}</div>
                </div>
            </div>

        </div>


    )
}

export default CardSlot